import { FaCalendarAlt, FaSearch } from 'react-icons/fa';
import { MdDashboard, MdDesignServices, MdOutlineWebAsset, MdContactSupport } from 'react-icons/md';
import { IoIosSettings } from 'react-icons/io';
import { BsPeopleFill } from 'react-icons/bs';
import { GiChicken } from 'react-icons/gi';
import { IoBookSharp } from 'react-icons/io5';

export const MenuList = [
  { title: 'sidebar.menu.overview',       iconStyle: <MdDashboard />,       to: '' },
  { title: 'sidebar.menu.services',       classsChange: 'mm-collapse',      iconStyle: <MdDesignServices />,   to: 'manage-services' },
  { title: 'sidebar.menu.staff',          classsChange: 'mm-collapse',      iconStyle: <BsPeopleFill />,       to: 'manage-staff' },
  { title: 'sidebar.menu.calendar',       classsChange: 'mm-collapse',      iconStyle: <FaCalendarAlt />,      to: 'calendar' },
  { title: 'sidebar.menu.roster',         classsChange: 'mm-collapse',      iconStyle: <GiChicken />,          to: 'roster' },
  { title: 'sidebar.menu.search',         iconStyle: <FaSearch />,          to: 'search' },
  { title: 'sidebar.menu.onlineBooking',  iconStyle: <IoBookSharp />,       to: 'online-booking' },
  { title: 'sidebar.menu.miniSite',       iconStyle: <MdOutlineWebAsset />, to: 'manage-site' },
  { title: 'sidebar.menu.support',        classsChange: 'mm-collapse',      iconStyle: <MdContactSupport />,   to: 'support' },
  { title: 'sidebar.menu.settings',       classsChange: 'mm-collapse',      iconStyle: <IoIosSettings />,      to: 'settings' }
];
